import React, { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import TableContainer from '../../../../../components/Common/TableContainer'
import { deleteAllowance as onDeleteAllowance } from '../../../../../slice/thunks'

export default function AllowancesTable({ data }) {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [deleteModal, setDeleteModal] = useState(false)
    const [selectedAllowance, setSelectedAllowance] = useState(null)

    const handleEditClick = (row) => {
        navigate(
            `/payroll/setting/allowances/edit/${row.id}/${row.allowanceName}/${row.rate}/${row.taxable}/${row.cnpsContribution}`
        )
    }

    const handleDeleteClick = (row) => {
        setSelectedAllowance(row)
        setDeleteModal(true)
    }

    const handleDeleteConfirm = () => {
        if (selectedAllowance) {
            dispatch(onDeleteAllowance(selectedAllowance.id))
        }
        setDeleteModal(false)
        setSelectedAllowance(null)
    }

    const handleDeleteCancel = () => {
        setDeleteModal(false)
        setSelectedAllowance(null)
    }

    const columns = useMemo(
        () => [
            {
                header: "No",
                style: "button",
                enableColumnFilter: false,
                cell: (cell) => (
                    <div className="d-flex gap-2">
                        {cell.row.index + 1}
                    </div>
                ),
            },
            {
                header: "Name",
                accessorKey: "allowanceName",
                style: "button",
                enableColumnFilter: false,
            },
            {
                header: "Rate",
                accessorKey: "rate",
                style: "button",
                enableColumnFilter: false,
            },
            {
                header: "Taxable",
                accessorKey: "taxable",
                style: "button",
                enableColumnFilter: false,
                cell: (cell) => (
                    <span className={`badge ${cell.getValue() ? 'bg-success' : 'bg-secondary'}`}>
                        {cell.getValue() ? 'Yes' : 'No'}
                    </span>
                ),
            },
            {
                header: "CNPS Contribution",
                accessorKey: "cnpsContribution",
                style: "button",
                enableColumnFilter: false,
                cell: (cell) => (
                    <span className={`badge ${cell.getValue() ? 'bg-success' : 'bg-secondary'}`}>
                        {cell.getValue() ? 'Yes' : 'No'}
                    </span>
                ),
            },
            {
                header: "Actions",
                accessorKey: "actions",
                style: "button",
                enableColumnFilter: false,
                cell: (cell) => (
                    <div className="d-flex gap-2">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() => handleEditClick(cell.row.original)}
                        >
                            Edit
                        </button>
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteClick(cell.row.original)}
                        >
                            Delete
                        </button>
                    </div>
                ),
            },
        ],
        []
    )

    return (
        <div className="card table-card">
            <TableContainer
                columns={columns}
                data={data.items}
                isGlobalFilter={true}
                customPageSize={data.size || 10}
                divClass="table-card-ward"
                tableClass="align-middle"
                theadClass="thead-light table-light"
                tableSize={data.size || 10}
                tablePage={data.page}
                tableTotal={data.total_items}
                tableTotalPage={data.total_page}
            />

            {/* Delete Confirmation Modal */}
            <Modal isOpen={deleteModal} toggle={handleDeleteCancel} centered>
                <ModalHeader toggle={handleDeleteCancel}>
                    Confirm Delete
                </ModalHeader>
                <ModalBody>
                    Are you sure you want to delete the allowance{' '}
                    <strong>{selectedAllowance?.allowanceName}</strong>? This action cannot be undone.
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-secondary" onClick={handleDeleteCancel}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={handleDeleteConfirm}>
                        Delete
                    </button>
                </ModalFooter>
            </Modal>
        </div>
    )
}